"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPagesItems = getPagesItems;
exports.getSocialMediaItems = getSocialMediaItems;
exports.icons = void 0;
var _reactIntl = require("react-intl");
var _AccountCircle = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/AccountCircle"));
var _Deals = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Deals"));
var _ContactEmail = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/ContactEmail"));
var _StarFull = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/StarFull"));
var _Trip = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Trip"));
var _City = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/City"));
var _Kiwicom = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Kiwicom"));
var _KiwicomCare = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/KiwicomCare"));
var _KiwicomGuarantee = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/KiwicomGuarantee"));
var _Code = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Code"));
var _Suitcase = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Suitcase"));
var _TermsAndConditions = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/TermsAndConditions"));
var _Settings = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Settings"));
var _Security = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Security"));
var _Facebook = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Facebook"));
var _Instagram = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Instagram"));
var _Twitter = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Twitter"));
var _Linkedin = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Linkedin"));
var _Chat = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Chat"));
var _Exchange = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Exchange"));
var _Partners = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Partners"));
const icons = {
  AccountCircle: _AccountCircle.default,
  Deals: _Deals.default,
  ContactEmail: _ContactEmail.default,
  Facebook: _Facebook.default,
  Instagram: _Instagram.default,
  StarFull: _StarFull.default,
  Kiwicom: _Kiwicom.default,
  KiwicomCare: _KiwicomCare.default,
  KiwicomGuarantee: _KiwicomGuarantee.default,
  Code: _Code.default,
  Suitcase: _Suitcase.default,
  TermsAndConditions: _TermsAndConditions.default,
  Security: _Security.default,
  City: _City.default,
  Twitter: _Twitter.default,
  Linkedin: _Linkedin.default,
  Trip: _Trip.default,
  Settings: _Settings.default,
  Chat: _Chat.default,
  Exchange: _Exchange.default,
  Partners: _Partners.default
};
exports.icons = icons;
const companyPagesUI = {
  stories: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.stories"
    }),
    Icon: icons.Trip
  },
  security: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.security_title"
    }),
    Icon: icons.Security
  },
  about: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.about.title"
    }),
    Icon: icons.City
  },
  terms: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.legal.title"
    }),
    Icon: icons.TermsAndConditions
  },
  gdpr_terms: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.terms.title"
    }),
    Icon: icons.TermsAndConditions
  },
  guarantee: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.guarantee.title"
    }),
    Icon: icons.KiwicomGuarantee
  },
  privacy: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.privacy.title"
    }),
    Icon: icons.Security
  },
  careers: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.careers.title"
    }),
    Icon: icons.Suitcase
  },
  media: {
    title: (0, _reactIntl.defineMessage)({
      id: "content.pages.media_room"
    }),
    Icon: icons.Kiwicom
  }
};
function getPagesItems(brand) {
  return Object.fromEntries(Object.entries(brand.content.pages).filter(([, page]) => page.enabled).map(([name, page]) => [name, {
    ...page,
    ...companyPagesUI[name]
  }]));
}

// TODO: missing translations common.instagram etc
const socialPagesUI = {
  instagram: {
    type: "instagram",
    Icon: icons.Instagram
  },
  twitter: {
    type: "twitter",
    Icon: icons.Twitter,
    label: (0, _reactIntl.defineMessage)({
      id: "common.twitter"
    })
  },
  youtube: {
    type: "youtube",
    Icon: icons.Kiwicom
  },
  linkedin: {
    type: "linkedin",
    Icon: icons.Linkedin
  },
  blog: {
    type: "blog",
    Icon: icons.Kiwicom
  },
  facebook: {
    type: "facebook",
    Icon: icons.Facebook,
    label: (0, _reactIntl.defineMessage)({
      id: "common.facebook"
    })
  }
};
function getSocialMediaItems(brand) {
  return Object.values(Object.entries(brand.content.pages).filter(([, page]) => page.enabled).map(([name, page]) => ({
    ...page,
    ...socialPagesUI[name]
  })));
}